(() => {
    if (!customElements.get("hoculus-scrolling-text")) return;

    class hoculusScrollingText extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            const observerOptions = {
                root: null,
                rootMargin: "0px",
            };
    
            function intersectionCallback(entries) {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        this.classList.remove("pause-animation");
                    } else {
                        this.classList.add("pause-animation");
                    }
                }
            }
    
            const observer = new IntersectionObserver(intersectionCallback.bind(this), observerOptions);
            observer.observe(this);
        }
    }
    
    customElements.define("hoculus-scrolling-text", hoculusScrollingText);
})()